"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.injectStyle = void 0;
var tslib_1 = require("tslib");
var version_1 = tslib_1.__importDefault(require("../common/version"));
var bundledBy = 'unknown';
try {
    var where = require('../../package.json')._where;
    var arr = where.split('/');
    bundledBy = arr[arr.length - 1];
}
catch (error) {
}
function injectStyle(fileKey, css) {
    if (typeof window === 'undefined') {
        return;
    }
    var key = version_1.default + "-" + fileKey;
    window.__duim_style_registry__ = window.__duim_style_registry__ || {};
    if (Array.isArray(window.__duim_style_registry__[key])) {
        window.__duim_style_registry__[key].push(bundledBy);
        warnRedundantInject(key);
        return;
    }
    window.__duim_style_registry__[key] = [bundledBy];
    var versions = getFileVersions(fileKey);
    if (versions.length > 1) {
        warnMultipleVersions(fileKey, versions);
    }
    var styleElement = document.createElement('style');
    styleElement.setAttribute('type', 'text/css');
    styleElement.setAttribute('data-duim-key', key);
    styleElement.innerText = css;
    document.head.appendChild(styleElement);
}
exports.injectStyle = injectStyle;
var CONSOLE_DEBOUNCE = 3000;
function warnRedundantInject(key) {
    if (!window.__duim_style_registry__ || !Array.isArray(window.__duim_style_registry__[key])) {
        return;
    }
    var count = window.__duim_style_registry__[key].length;
    setTimeout(function () {
        if (window.__duim_style_registry__[key].length > count) {
            return;
        }
        console.warn("[DUI-MOBILE] " + key + " \u91CD\u590D\u5F15\u5165\u4E86 " + count + " \u6B21");
    }, CONSOLE_DEBOUNCE);
}
function warnMultipleVersions(fileKey, versions) {
    setTimeout(function () {
        if (getFileVersions(fileKey).length > versions.length) {
            return;
        }
        console.error("[DUI-MOBILE] " + fileKey + " \u5B58\u5728\u591A\u7248\u672C\u8986\u76D6:  " + versions.join('  '));
    }, CONSOLE_DEBOUNCE);
}
function getFileVersions(fileKey) {
    if (!window.__duim_style_registry__) {
        return [];
    }
    var existingKeys = Object.getOwnPropertyNames(window.__duim_style_registry__);
    return existingKeys.filter(function (k) { return k.indexOf(fileKey) !== -1; }).map(function (k) { return k.split('-')[0]; });
}
